import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { ChannelCategory } from 'ops/common/models/channel-category';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ChannelCategoryService {
    private domain: string;

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    public getChannelCategories(): Promise<ChannelCategory[]> {
        return lastValueFrom(
            this.http.get<ChannelCategory[]>(`${this.domain}/api/channel-categories`),
        );
    }
}
